"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _program = require("../../../actions/program");
var _actionUtils = require("../../../utils/actionUtils");
function presenterFeatured(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector,
    presenterId = _ref2.presenterId;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _program.syncFeaturedPresenter)(presenterId));
  }
}
var _default = exports["default"] = presenterFeatured;